import { createDropdownOptions } from 'src/helpers/formHelpers'
import { useClearances, useContractTypes, useHiringManagers, usePositionExemptStatuses, usePositionPriorities, usePositionStatuses, useProgramManagers } from 'src/queries'

export interface UseLookupsReturn {
  contractTypes: ReturnType<typeof useContractTypes>
  statuses: ReturnType<typeof createDropdownOptions>
  priorities: ReturnType<typeof usePositionPriorities>
  programManagers: ReturnType<typeof useProgramManagers>
  hiringManagers: ReturnType<typeof useHiringManagers>
  clearances: ReturnType<typeof useClearances>
  exemptStatuses: ReturnType<typeof createDropdownOptions>
}

const useLookups = (): UseLookupsReturn => {
  const statuses = usePositionStatuses()
  const contractTypes = useContractTypes()
  const priorities = usePositionPriorities()
  const programManagers = useProgramManagers()
  const hiringManagers = useHiringManagers()
  const clearances = useClearances()
  const exemptStatuses = usePositionExemptStatuses()
  return {
    statuses: createDropdownOptions(statuses),
    contractTypes,
    priorities,
    programManagers,
    hiringManagers,
    clearances,
    exemptStatuses: createDropdownOptions(exemptStatuses)
  }
}

export default useLookups
